(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cinematic-category-showcase"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  if (window.CinematicShowcase) { return; }

  var clamp = function (v, a, b) { return v < a ? a : (v > b ? b : v); };
  var smoother = function (t) { return t * t * t * (t * (t * 6 - 15) + 10); };
  var easeOut = function (t) { return 1 - Math.pow(1 - t, 3); };
  var r3 = function (n) { return Math.round(n * 1000) / 1000; };
  var mq = function (q) { return window.matchMedia(q); };
  var mqWide = mq('(min-width: 990px)');
  var mqTablet = mq('(min-width: 750px)');
  var mqReduce = mq('(prefers-reduced-motion: reduce)');
  var mqHover = mq('(hover: hover) and (pointer: fine)');
  var listen = function (m, fn) { if (m.addEventListener) { m.addEventListener('change', fn); } else if (m.addListener) { m.addListener(fn); } };
  var unlisten = function (m, fn) { if (m.removeEventListener) { m.removeEventListener('change', fn); } else if (m.removeListener) { m.removeListener(fn); } };

  function Showcase(root) {
    var self = this;
    var d = root.dataset;
    var n = function (k, def) { var v = parseFloat(d[k]); return isNaN(v) ? def : v; };
    this.root = root;
    this.cfg = {
      anim: d.anim === 'true', mouse: d.mouse === 'true', parallax: d.parallax === 'true', three: d.three === 'true',
      reduced: d.reduced === 'true', pin: d.pin === 'true',
      persp: n('persp', 1400), rot: n('rot', 10), depth: n('depth', 240), tilt: n('tilt', 6),
      srot: n('srot', 5), sscale: n('sscale', 6) / 100, par: n('par', 36), flt: n('flt', 32),
      smooth: n('smooth', 10), hold: n('hold', 30), stagger: n('stagger', 100), scroll: n('scroll', 120),
      peek: n('peek', 16) / 100, sticky: n('sticky', 0), dspeed: n('dspeed', 100) / 100
    };
    this.track = root.querySelector('[data-cs-track]');
    this.stage = root.querySelector('[data-cs-stage]');
    this.tints = [].slice.call(root.querySelectorAll('[data-cs-tint]'));
    this.shapes = [].slice.call(root.querySelectorAll('[data-cs-shape]'));
    this.navBtns = [].slice.call(root.querySelectorAll('[data-cs-go]'));
    this.slides = [].slice.call(root.querySelectorAll('[data-cs-slide]')).map(function (el) {
      var q = function (sel) { return el.querySelector(sel); };
      return {
        el: el, content: q('[data-cs-content]'), media: q('[data-cs-media]'), depth: q('[data-cs-depth]'),
        float: q('[data-cs-float]'), card: q('[data-cs-card]'), img: q('[data-cs-img]'), glass: q('[data-cs-glass]'),
        btnWrap: q('[data-cs-cta]'), btn: q('[data-cs-btn]'), rows: [].slice.call(el.querySelectorAll('[data-cs-r]')),
        side: q('.cs__grid').getAttribute('data-side') === 'left' ? -1 : 1,
        mx: 0, my: 0, tx: 0, ty: 0, px: null, py: null, hover: false, q: 0, near: true, active: null, vis: null
      };
    });
    this.mode = 'static';
    this.pos = 0; this.target = 0; this.cur = -1; this.range = 1; this.travel = 0;
    this.raf = 0; this.last = 0; this.visible = true; this.snap = true; this.hoverOK = false; this.rz = 0;
    this.tick = this.tick.bind(this);
    this.onScroll = function () { self.schedule(); };
    this.onResize = function () {
      cancelAnimationFrame(self.rz);
      self.rz = requestAnimationFrame(function () { self.evaluate(); });
    };
    this.bind();
    this.evaluate();
  }

  Showcase.prototype.bind = function () {
    var self = this;
    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onResize, { passive: true });
    listen(mqWide, this.onResize); listen(mqReduce, this.onResize); listen(mqHover, this.onResize); listen(mqTablet, this.onResize);

    if ('IntersectionObserver' in window) {
      this.io = new IntersectionObserver(function (entries) {
        self.visible = entries[0].isIntersecting;
        if (self.visible) { self.schedule(); }
      }, { rootMargin: '150px 0px' });
      this.io.observe(this.root);
    }

    this.slides.forEach(function (s) {
      s.media.addEventListener('pointermove', function (e) {
        if (e.pointerType !== 'mouse' || !self.hoverOK) { return; }
        s.px = e.clientX; s.py = e.clientY; s.hover = true; self.schedule();
      }, { passive: true });
      s.media.addEventListener('pointerleave', function () { s.hover = false; s.px = null; self.schedule(); }, { passive: true });
      if (s.btnWrap && s.btn) {
        s.btnWrap.addEventListener('pointermove', function (e) {
          if (e.pointerType !== 'mouse' || !self.hoverOK) { return; }
          var r = s.btnWrap.getBoundingClientRect();
          var dx = (e.clientX - (r.left + r.width / 2)) * 0.28;
          var dy = (e.clientY - (r.top + r.height / 2)) * 0.28;
          s.btn.style.transform = 'translate3d(' + r3(clamp(dx, -12, 12)) + 'px,' + r3(clamp(dy, -8, 8)) + 'px,0)';
        }, { passive: true });
        s.btnWrap.addEventListener('pointerleave', function () { s.btn.style.transform = ''; }, { passive: true });
      }
    });

    this.navBtns.forEach(function (b, i) {
      b.addEventListener('click', function () { self.goTo(i, false); });
    });
  };

  Showcase.prototype.evaluate = function () {
    var c = this.cfg;
    var reduce = c.reduced && mqReduce.matches;
    var enabled = c.anim && !reduce;
    var mode = !enabled ? 'static' : ((c.pin && mqWide.matches && window.innerHeight >= 520) ? 'pinned' : 'flow');
    this.hoverOK = enabled && c.mouse && mqHover.matches;
    if (mode !== this.mode) { this.setMode(mode); }
    else if (mode === 'pinned') { this.measure(); }
    this.schedule();
  };

  Showcase.prototype.setMode = function (mode) {
    var r = this.root;
    r.classList.remove('is-pinned', 'is-flow', 'cs--js', 'cs--reveal');
    if (this.revealIO) { this.revealIO.disconnect(); this.revealIO = null; }
    this.resetStyles();
    this.mode = mode;
    if (mode === 'static') { return; }
    r.classList.add('cs--js');
    this.snap = true;
    if (mode === 'pinned') {
      r.classList.add('is-pinned');
      this.measure();
    } else {
      r.classList.add('is-flow');
      this.setupReveal();
    }
  };

  Showcase.prototype.setupReveal = function () {
    var self = this;
    if (!('IntersectionObserver' in window)) { return; }
    this.root.classList.add('cs--reveal');
    this.revealIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); self.revealIO.unobserve(e.target); }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -6% 0px' });
    this.slides.forEach(function (s) {
      if (!s.el.classList.contains('is-in')) { self.revealIO.observe(s.el); }
    });
  };

  Showcase.prototype.measure = function () {
    var n = this.slides.length;
    var stageH = this.stage.offsetHeight;
    var extra = Math.max(n - 1, 0) * window.innerHeight * this.cfg.scroll / 100;
    this.range = Math.max(extra, 1);
    this.travel = stageH * 0.06;
    this.track.style.height = (stageH + extra) + 'px';
  };

  Showcase.prototype.resetStyles = function () {
    this.track.style.height = '';
    this.slides.forEach(function (s) {
      s.el.style.zIndex = ''; s.el.style.visibility = ''; s.el.classList.remove('is-active');
      s.content.style.cssText = ''; s.media.style.cssText = ''; s.depth.style.cssText = '';
      s.float.style.cssText = ''; s.img.style.cssText = ''; s.glass.style.cssText = ''; s.card.style.cssText = '';
      if (s.btn) { s.btn.style.cssText = ''; }
      s.rows.forEach(function (r) { r.style.cssText = ''; });
      s.active = null; s.vis = null; s.mx = s.my = s.tx = s.ty = 0;
    });
    this.tints.forEach(function (t) { t.style.opacity = ''; });
    this.shapes.forEach(function (t) { t.style.cssText = ''; });
    this.navBtns.forEach(function (b) { b.classList.remove('is-on'); b.removeAttribute('aria-current'); });
    this.cur = -1;
  };

  Showcase.prototype.schedule = function () {
    if (this.raf || this.mode === 'static' || !this.visible) { return; }
    this.raf = requestAnimationFrame(this.tick);
  };

  // Category transition curve: each category holds still, then eases to the next.
  Showcase.prototype.shape = function (pos) {
    var n = this.slides.length;
    var base = Math.floor(pos + 1e-6), f = pos - base, h = this.cfg.hold / 200;
    var t = clamp((f - h) / (1 - 2 * h), 0, 1);
    return Math.min(base + smoother(t), n - 1);
  };

  Showcase.prototype.tick = function (now) {
    var self = this, c = this.cfg, n = this.slides.length, vh = window.innerHeight;
    var pinned = this.mode === 'pinned';
    var busy = false;
    this.raf = 0;
    var dt = this.last ? Math.min(now - this.last, 64) : 16.7;
    this.last = now;
    var step = dt / 16.7;

    // ---- READ phase (no style writes) ----
    var rr = this.root.getBoundingClientRect();
    if (pinned) {
      var tr = this.track.getBoundingClientRect();
      this.target = clamp((c.sticky - tr.top) / this.range, 0, 1) * Math.max(n - 1, 0);
    } else {
      this.slides.forEach(function (s) {
        var r = s.el.getBoundingClientRect();
        s.q = clamp((r.top + r.height / 2 - vh / 2) / vh, -1, 1);
        s.near = r.bottom > -vh * 0.2 && r.top < vh * 1.2;
      });
    }
    this.slides.forEach(function (s) {
      if (s.hover && s.px !== null && self.hoverOK) {
        var r = s.media.getBoundingClientRect();
        var hw = Math.max(s.card.offsetWidth / 2, 1), hh = Math.max(s.card.offsetHeight / 2, 1);
        s.tx = clamp((s.px - (r.left + r.width / 2)) / hw, -1, 1);
        s.ty = clamp((s.py - (r.top + r.height / 2)) / hh, -1, 1);
      } else { s.tx = 0; s.ty = 0; }
    });

    // ---- Smoothing ----
    if (pinned) {
      var diff = this.target - this.pos;
      if (this.snap || Math.abs(diff) < 0.0008) { this.pos = this.target; this.snap = false; }
      else { this.pos += diff * (1 - Math.pow(1 - c.smooth / 100, step)); busy = true; }
    }
    var mk = 1 - Math.pow(0.88, step);
    this.slides.forEach(function (s) {
      var dx = s.tx - s.mx, dy = s.ty - s.my;
      if (Math.abs(dx) > 0.002 || Math.abs(dy) > 0.002) { s.mx += dx * mk; s.my += dy * mk; busy = true; }
      else { s.mx = s.tx; s.my = s.ty; }
    });

    // ---- WRITE phase ----
    if (pinned) { this.writePinned(); } else { this.writeFlow(rr, vh); }
    if (busy) { this.schedule(); }
  };

  Showcase.prototype.writePinned = function () {
    var self = this, c = this.cfg, n = this.slides.length;
    var sp = this.shape(this.pos);
    var sf = Math.min(c.stagger / 1000, 0.22);
    this.slides.forEach(function (s, i) {
      var d = sp - i, ad = Math.abs(d);
      if (ad >= 2) {
        if (s.vis !== false) { s.vis = false; s.active = null; s.el.style.visibility = 'hidden'; s.el.classList.remove('is-active'); }
        if (self.tints[i]) { self.tints[i].style.opacity = '0'; }
        return;
      }
      if (s.vis !== true) { s.vis = true; s.el.style.visibility = ''; }
      var active = ad < 0.5;
      if (active !== s.active) {
        s.active = active;
        s.el.classList.toggle('is-active', active);
        s.content.style.visibility = active ? '' : 'hidden';
      }
      s.el.style.zIndex = String(Math.round((2 - ad) * 10));
      var q = clamp(self.pos - i, -1, 1);
      self.writeSlide(s, { d: d, ad: ad, q: q, flow: false });

      // Staggered text: kicker, title (mask), description, CTA
      var g = clamp((0.5 - ad) / 0.42, 0, 1), den = 1 - 3 * sf, dir = d < 0 ? 1 : -1;
      s.rows.forEach(function (el) {
        var k = parseInt(el.getAttribute('data-cs-r'), 10) || 0;
        var e = easeOut(clamp((g - k * sf) / den, 0, 1));
        if (k === 1) {
          if (e > 0.999) { el.style.clipPath = 'none'; }
          else {
            var h = r3((1 - e) * 130);
            el.style.clipPath = d < 0
              ? 'inset(calc(' + h + '% - 0.2em) -0.15em -0.3em -0.15em)'
              : 'inset(-0.2em -0.15em calc(' + h + '% - 0.3em) -0.15em)';
          }
          el.style.transform = 'translate3d(0,' + r3(dir * (1 - e) * 36) + 'px,0)';
        } else {
          el.style.opacity = String(r3(e));
          el.style.transform = 'translate3d(0,' + r3(dir * (1 - e) * 24) + 'px,0)';
        }
      });
      if (self.tints[i]) { self.tints[i].style.opacity = String(r3(1 - Math.min(ad, 1))); }
    });

    var cur = clamp(Math.round(sp), 0, n - 1);
    if (cur !== this.cur) {
      this.cur = cur;
      this.navBtns.forEach(function (b, i) {
        b.classList.toggle('is-on', i === cur);
        b.setAttribute('aria-current', i === cur ? 'true' : 'false');
      });
    }
    this.writeShapes(this.pos);
  };

  Showcase.prototype.writeFlow = function (rr, vh) {
    var self = this, n = this.slides.length;
    this.slides.forEach(function (s) {
      if (s.near) { self.writeSlide(s, { d: 0, ad: 0, q: s.q, flow: true }); }
    });
    this.writeShapes(clamp((vh - rr.top) / (rr.height + vh), 0, 1) * Math.max(n - 1, 1));
  };

  Showcase.prototype.writeSlide = function (s, v) {
    var c = this.cfg, flow = v.flow, q = v.q, hv = this.hoverOK, three = c.three;
    var z = 0, ty = 0, rx = 0, ry = 0, sc;
    if (!flow) {
      if (three) {
        z = -v.ad * c.depth;
        rx = -q * c.srot * 0.8 + v.d * c.rot * 0.4;
        ry = -v.d * c.rot * s.side + q * c.srot * 0.6;
      }
      ty = -v.d * this.travel;
      sc = (1 - 0.07 * v.ad) * (1 - c.sscale * Math.min(Math.abs(q) * 2, 1));
      var op = v.ad <= 1 ? 1 - v.ad * (1 - c.peek) : c.peek * (2 - v.ad);
      s.media.style.opacity = String(r3(clamp(op, 0, 1)));
    } else {
      if (three && mqTablet.matches) { rx = q * c.srot * 0.35; }
      sc = 1 - Math.min(Math.abs(q), 1) * c.sscale * 0.6;
    }
    s.depth.style.transform = 'translate3d(0,' + r3(ty) + 'px,' + r3(z) + 'px) rotateX(' + r3(rx) + 'deg) rotateY(' + r3(ry) + 'deg) scale(' + r3(sc) + ')';

    var par = c.parallax, pq = clamp(q, -0.5, 0.5);
    var mx = hv ? s.mx : 0, my = hv ? s.my : 0;
    s.img.style.transform = 'translate3d(' + r3(par ? -mx * 10 : 0) + 'px,' + r3(par ? -pq * 2 * c.par * 0.9 - my * 8 : 0) + 'px,0)';
    s.float.style.transform = 'translate3d(' + r3(par ? -mx * 14 : 0) + 'px,' + r3(par ? q * c.flt * 2 - my * 10 : 0) + 'px,0)';

    var tilt = (three && hv) ? c.tilt * (mqWide.matches ? 1 : 0.5) : 0;
    s.card.style.transform = tilt
      ? 'perspective(' + c.persp + 'px) rotateX(' + r3(-my * tilt) + 'deg) rotateY(' + r3(mx * tilt) + 'deg)'
      : '';
    s.card.style.setProperty('--mx', String(r3(clamp(0.5 + mx * 0.5 - q * 0.5, -0.2, 1.2))));
    s.card.style.setProperty('--my', String(r3(clamp(0.3 + my * 0.5 + q * 0.25, -0.2, 1.2))));
    s.card.style.setProperty('--sx', r3(-mx * 18) + 'px');
    s.card.style.setProperty('--sy', r3(-my * 14) + 'px');
    s.glass.style.transform = 'translate3d(' + r3(q * 35) + '%,0,0)';
    s.content.style.transform = (hv && (mx || my)) ? 'translate3d(' + r3(-mx * 8) + 'px,' + r3(-my * 6) + 'px,0)' : '';
  };

  Showcase.prototype.writeShapes = function (p) {
    var t = this.shapes, sp = this.cfg.dspeed;
    if (!t.length) { return; }
    if (t[0]) { t[0].style.transform = 'translate3d(0,' + r3(-p * 50 * sp) + 'px,0) rotate(' + r3(p * 16 * sp) + 'deg)'; }
    if (t[1]) { t[1].style.transform = 'translate3d(' + r3(p * 70 * sp) + 'px,' + r3(-p * 120 * sp) + 'px,0)'; }
    if (t[2]) { t[2].style.transform = 'translate3d(0,' + r3(p * 70 * sp) + 'px,0)'; }
  };

  Showcase.prototype.goTo = function (i, instant) {
    var n = this.slides.length, behavior = instant ? 'auto' : 'smooth';
    if (this.mode !== 'pinned') {
      this.slides[i].el.scrollIntoView({ behavior: behavior, block: 'start' });
      return;
    }
    var top = this.track.getBoundingClientRect().top + window.pageYOffset;
    var y = top - this.cfg.sticky + (n > 1 ? i / (n - 1) : 0) * this.range;
    window.scrollTo({ top: y, behavior: behavior });
  };

  Showcase.prototype.destroy = function () {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onResize);
    unlisten(mqWide, this.onResize); unlisten(mqReduce, this.onResize);
    unlisten(mqHover, this.onResize); unlisten(mqTablet, this.onResize);
    cancelAnimationFrame(this.raf); cancelAnimationFrame(this.rz);
    if (this.io) { this.io.disconnect(); }
    this.setMode('static');
    delete this.root._cs;
  };

  function create(root) {
    if (!root || root._cs) { return; }
    root._cs = new Showcase(root);
  }
  function boot() {
    [].forEach.call(document.querySelectorAll('[data-cs]'), create);
  }

  window.CinematicShowcase = { create: create };

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); }
  else { boot(); }

  // Shopify theme editor support
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector ? e.target.querySelector('[data-cs]') : null;
    if (r) { create(r); }
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var r = e.target.querySelector ? e.target.querySelector('[data-cs]') : null;
    if (r && r._cs) { r._cs.destroy(); }
  });
  document.addEventListener('shopify:block:select', function (e) {
    var root = e.target.closest ? e.target.closest('[data-cs]') : null;
    if (!root || !root._cs) { return; }
    root._cs.slides.forEach(function (s, i) { if (s.el === e.target) { root._cs.goTo(i, true); } });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
